new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        // Showcase
        showOpened: false,
        expandDesc: false,
        installmentOpened: false,

        //Thumb
        imgSrc: '',
        imgTitle: '',
        isVideo: '',
        currentImageIndex: 0,
        images: []
    },
    methods: {
        resizeThumbs() {
            const contentThumbs = document.querySelector('#product-photo');
            const imgThumb = document.querySelector('#product-photo img');
            if (contentThumbs && imgThumb) {
                let heightImg = imgThumb.getBoundingClientRect().height;
                contentThumbs.style.minHeight = heightImg + 'px';
            }
        },
        clickThumbs() {
            let photoArea = document.querySelector('.product-detail__header--photoArea');
            let photoThumbs = document.querySelector('.product-detail__header--photoArea-thumbs');

            if (photoThumbs && photoArea) {
                if (photoArea.classList.contains('gallery-left') || photoArea.classList.contains('gallery-right') || photoArea.classList.contains('gallery-bottom')) {

                    let photoListItem = document.querySelectorAll('#photo-list li');
                    let singlePhotoItem = document.querySelectorAll('#product-photo img');

                    if (photoListItem.length && singlePhotoItem.length) {
                        photoListItem[0].classList.add('active');
                        singlePhotoItem[0].classList.add('active');

                        function activeTab(index) {
                            singlePhotoItem.forEach((content) => {
                                content.classList.remove('active');
                            });
                            singlePhotoItem[index].classList.add('active');
                        }

                        photoListItem.forEach((itemMenu, index) => {
                            itemMenu.addEventListener('click', () => {
                                activeTab(index);
                            });
                        });
                    }
                }
            }

            if (photoThumbs && photoArea) {
                if (photoThumbs.classList.contains('gallery-left') || photoThumbs.classList.contains('gallery-right')) {
                    $('#photo-list').slick({
                        infinite: false,
                        slidesToShow: 5,
                        vertical: true,
                        slidesToScroll: 1
                    });
                }
            }
        },
        nextImage() {
            if (this.images.length > 0) {
                this.currentImageIndex = (this.currentImageIndex + 1) % this.images.length;
                this.updateImageThumb(this.images[this.currentImageIndex]);
            }
        },
        prevImage() {
            if (this.images.length > 0) {
                this.currentImageIndex = (this.currentImageIndex - 1 + this.images.length) % this.images.length;
                this.updateImageThumb(this.images[this.currentImageIndex]);
            }
        },
        updateImageThumb(src) {
            this.imgSrc = src;
            this.currentImageIndex = this.images.indexOf(src);
        },

        setThumbHeight() {
            return document.querySelector('.product-detail__header--photoArea-thumbs').style.height = document.querySelector('#photo-list li.visible').clientHeight * this.slidesToShow + 'px;';
        },

        handleESC(event) {
            if (event.key === 'Escape')
                this.showOpened = false
        },

        checkBuyView() {
            const buyButton = document.getElementById("buy-button");
            const rect = buyButton.getBoundingClientRect();

            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.remove("active");
                }
            } else {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.add("active");
                }
            }
        },

        zoom(event) {
            const container = document.getElementById('zoom-container');
            const image = document.getElementById('zoom-image');

            const containerRect = container.getBoundingClientRect();
            const mouseX = event.clientX - containerRect.left;
            const mouseY = event.clientY - containerRect.top;

            if (mouseX >= 0 && mouseX <= containerRect.width && mouseY >= 0 && mouseY <= containerRect.height) {
                const zoomLevel = 1.2;
                const newWidth = container.offsetWidth * zoomLevel;
                const newHeight = container.offsetHeight * zoomLevel;

                const offsetX = -(mouseX * (zoomLevel - 1));
                const offsetY = -(mouseY * (zoomLevel - 1));

                image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`;

                if (offsetX > 0) {
                    image.style.transform = `translate(0, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY > 0) {
                    image.style.transform = `translate(${offsetX}px, 0) scale(${zoomLevel})`;
                }
                if (offsetX < -(newWidth - container.offsetWidth)) {
                    image.style.transform = `translate(${- (newWidth - container.offsetWidth)}px, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY < -(newHeight - container.offsetHeight)) {
                    image.style.transform = `translate(${offsetX}px, ${- (newHeight - container.offsetHeight)}px) scale(${zoomLevel})`;
                }
            }
        },

        resetZoom() {
            const image = document.getElementById('zoom-image');
            image.style.transform = 'translate(0, 0) scale(1)';
        },

        initializeImages() {
            const photoList = document.getElementById("photo-list");
            if (photoList) {
                const images = photoList.querySelectorAll("img");
                this.images = Array.from(images).map(img => img.getAttribute("src"));

                if (this.images.length > 0) {
                    this.imgSrc = this.images[0];
                    this.imgTitle = images[0].getAttribute("title");
                }
            }
        }
    },
    mounted() {
        this.initializeImages();
        this.resizeThumbs();
        this.clickThumbs();

        const ratingName = document.querySelector('.product-detail__rating__amount');
        if (ratingName !== null)
            if (ratingName.textContent === 'Seja o primeiro a avaliar')
                ratingName.textContent = 'Avaliar';

        const userLetterElement = document.getElementById('user_letter');
        if (userLetterElement) {
            const userLetter = userLetterElement.innerText.trim();
            if (userLetter.length > 0) {
                userLetterElement.innerText = userLetter[0];
            }
        }

        document.addEventListener('keydown', this.handleESC, { passive: true });
        window.addEventListener("scroll", this.checkBuyView, { passive: true });
        window.addEventListener("load", this.checkBuyView, { passive: true });
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleESC);
    },
    watch: {
        showOpened(newValue) {
            if (newValue) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.removeProperty('overflow');
            }
        },
    }
})

$(document).ready(function () {

    const faqItems = document.querySelectorAll('.faq-item');

    faqItems.forEach(item => {
        const title = item.querySelector('.faq-item__title');
        const content = item.querySelector('.faq-item__content');

        // Inicialmente esconde o conteúdo
        content.style.maxHeight = '0';
        content.style.overflow = 'hidden';
        content.style.transition = 'max-height 0.3s ease-out';

        title.addEventListener('click', () => {
            // Fecha todos os outros itens
            faqItems.forEach(otherItem => {
                if (otherItem !== item) {
                    const otherContent = otherItem.querySelector('.faq-item__content');
                    otherContent.style.maxHeight = '0';
                    otherItem.classList.remove('active');
                }
            });

            // Alterna o item atual
            const isActive = item.classList.contains('active');
            item.classList.toggle('active');

            if (isActive) {
                content.style.maxHeight = '0';
            } else {
                content.style.maxHeight = content.scrollHeight + 'px';
            }
        });
    });

    const brinde = document.querySelector('#js_buy_together_api_layout_2');

    if (brinde) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                    }
                });
            });
        });

        observer.observe(brinde, {
            childList: true,
            subtree: true
        });

    }

    $('.slick-photo-list').slick({
        infinite: false,
        arrows: false,
        slidesToShow: 4,
        slidesToScroll: 1
    });

    $("body").on("click", '.minus', function (event) {
        var qtd = $('#product_qtd__product_detail').val();

        if (qtd == 1) {
            return;
        } else {
            qtd--;
            $('#product_qtd__product_detail').val(qtd);
            $('#product_qtd__product_detail').attr('value', qtd)
        }
    });

    $("body").on("click", '.plus', function (event) {
        var qtd = $('#product_qtd__product_detail').val();

        qtd++;
        $('#product_qtd__product_detail').val(qtd);
        $('#product_qtd__product_detail').attr('value', qtd)
    });

    const galleryCarrousel = document.querySelector('.gallery-carrousel');
    if (galleryCarrousel) {
        $('.gallery-carrousel').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            infinite: false,
            mobileFirst: true,
            speed: 1000,
            vertical: false,
        });
    }

    // const photoList = document.querySelector('#photo-list');
    // if(photoList) {
    //     $('#photo-list').slick({
    //         slidesToShow: 5,
    //         slidesToScroll: 1,
    //         arrows: false,
    //         dots: false,
    //         infinite: false,
    //         mobileFirst: true,
    //         speed: 700,
    //         vertical: false,
    //     });
    // }

    (() => {
        const entregaEl = document.querySelector(".prazo-entrega");

        if (entregaEl) {
            const daysEl = entregaEl.querySelector(".prazo-entrega-days");

            if (daysEl) {
                const leapDays = Number.parseInt(entregaEl.dataset.leapDays, 10);
                const prazoEntrega = Number.parseInt(
                    daysEl.dataset.prazoEntrega,
                    10
                );

                if (
                    Number.isInteger(leapDays) &&
                    Number.isInteger(prazoEntrega) &&
                    leapDays >= 0 &&
                    prazoEntrega >= 0
                ) {
                    const mesesAbreviados = [
                        "jan.",
                        "fev.",
                        "mar.",
                        "abr.",
                        "mai.",
                        "jun.",
                        "jul.",
                        "ago.",
                        "set.",
                        "out.",
                        "nov.",
                        "dez."
                    ];

                    // Adiciona dias úteis, ignorando sábados e domingos.
                    function adicionarDiasUteis(data, quantidade) {
                        const novaData = new Date(data);
                        let diasAdicionados = 0;

                        while (diasAdicionados < quantidade) {
                            novaData.setDate(novaData.getDate() + 1);

                            const diaDaSemana = novaData.getDay();
                            const ehFimDeSemana =
                                diaDaSemana === 0 || diaDaSemana === 6;

                            if (!ehFimDeSemana) {
                                diasAdicionados += 1;
                            }
                        }

                        return novaData;
                    }

                    function formatarData(data) {
                        const dia = data.getDate();
                        const mes = mesesAbreviados[data.getMonth()];

                        return `<b>${dia} de ${mes}</b>`;
                    }

                    const hoje = new Date();
                    const dataInicio = adicionarDiasUteis(hoje, leapDays);
                    const dataFim = adicionarDiasUteis(
                        dataInicio,
                        prazoEntrega
                    );

                    daysEl.innerHTML = `${formatarData(dataInicio)} e ${formatarData(
                        dataFim
                    )}`;
                }
            }
        }

        waitForElementToExist(
            "#js-product_attributes__product_detail_ .atributes"
        ).then(() => {
            const $carrossel = $("#carrousel-atributes");

            if (
                !$carrossel.length ||
                $carrossel.hasClass("slick-initialized")
            ) {
                return;
            }

            $carrossel.slick({
                swipeToSlide: true,
                touchThreshold: 100,
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                speed: 700
            });
        });
    })();

    const photoMobile = document.querySelector('.product-detail__header--photoArea-mobile');
    if (photoMobile) {
        $('.product-detail__header--photoArea-mobile').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            speed: 700,
            vertical: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                },
            ]
        });
    }

    $('#product-detail-related-carrousel').slick({
        arrows: true,
        dots: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        speed: 700,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    dots: false,
                    slidesToShow: 4,
                }
            }
        ]
    });

    $('#product-detail-related-carrousel').on('afterChange', function (event, slick, currentSlide, nextSlide) {
        Blazy({
            selector: '.lazy-img',
            successClass: 'loaded-img',
            success: function (element) {
                setTimeout(function () {
                    var parent = element.previousSibling;
                    try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                }, 200);
            }
        });
    });

    $('.product__colors.attribute').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        speed: 700,
        vertical: false,
        responsive: [
            {
                breakpoint: 768,
                settings: "unslick"
            },
        ]
    });

    $('#photo-fancy').fancybox();

    const headers = document.querySelectorAll('.product-detail__description-tab h2');
    const descriptions = document.querySelectorAll('.description');

    headers.forEach(header => {
        header.addEventListener('click', () => {
            headers.forEach(h => h.classList.remove('active'));
            descriptions.forEach(description => description.classList.remove('active'));

            header.classList.add('active');

            const index = header.getAttribute('data-index');

            const activeDescription = document.querySelector(`.description[data-index="${index}"]`);
            activeDescription.classList.add('active');
        });
    });

    let description = document.querySelector('.description-nav');
        if (description) {
            let navTab = description.querySelectorAll('.nav-item');
            let navShow = description.querySelectorAll('.description-nav-content');
            navTab = Array.from(navTab);
            navShow = Array.from(navShow);

            if (navTab.length && navShow.length) {
                function toggleTab(index) {
                    const isActive = navTab[index].classList.contains('active');

                    // remove todas as classes active
                    navTab.forEach((content) => content.classList.remove('active'));
                    navShow.forEach((content) => content.classList.remove('active'));

                    // se não estava ativo, ativa
                    if (!isActive) {
                        navTab[index].classList.add('active');
                        navShow[index].classList.add('active');
                    }
                }

                navTab.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', () => {
                        toggleTab(index);
                    });
                });
            }
        }
})